/* Cart saver: "E-mail Me My Cart" in the cart drawer and the Klaviyo pop-up.
   Feeds Klaviyo flow "Nosto Cart Recover"
   (UiuWLD) with the same Cart Started event the Nosto template sent.
   Property names below are read by that flow's templates: do not rename. */
(function () {
  var COMPANY_ID = 'CNszUC';
  var REVISION = '2024-10-15';
  var LIST_NEWSLETTER = 'Bg8E3v';
  var SOURCE = 'cart-drawer-saver';
  var POPUP_SOURCE = 'cart-save-popup';
  var BASE = 'https://a.klaviyo.com/client/';

  function dollars(cents) { return Math.round(cents) / 100; }
  function absImage(url) {
    if (!url) return '';
    return url.indexOf('//') === 0 ? 'https:' + url : url;
  }
  function isValidEmail(email) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim()); }

  function buildReclaimUrl(origin, items) {
    return origin + '/cart/' + items.map(function (item) { return item.variant_id + ':' + item.quantity; }).join(',');
  }

  function buildSubscription(email, listId) {
    return { data: { type: 'subscription', attributes: { custom_source: SOURCE, profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: listId } } } } };
  }

  function buildCartStartedEvent(email, cart, origin, source) {
    var value = dollars(cart.total_price);
    return { data: { type: 'event', attributes: {
      metric: { data: { type: 'metric', attributes: { name: 'Cart Started' } } },
      properties: {
        'Items Count': cart.item_count,
        'Items': cart.items.map(function (i) { return i.title; }).join(', '),
        'Cart Value': value,
        'reclaimURL': buildReclaimUrl(origin, cart.items),
        'Products': { line_items: cart.items.map(function (i) {
          return { id: String(i.product_id), quantity: i.quantity, sku: String(i.variant_id), name: i.title, price: dollars(i.final_price), image: absImage(i.image) };
        }) }
      },
      value: value,
      value_currency: cart.currency || 'USD',
      profile: { data: { type: 'profile', attributes: { email: email, properties: { $source: source || SOURCE } } } }
    } } };
  }

  var inFlight = false;
  function post(fetchFn, endpoint, body) {
    return fetchFn(BASE + endpoint + '/?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(body)
    });
  }

  async function sendCartStarted(input, deps) {
    var email = String(input.email || '').trim();
    if (!isValidEmail(email)) return { ok: false, reason: 'invalid-email' };
    if (inFlight) return { ok: false, reason: 'in-flight' };
    inFlight = true;
    try {
      var cartRes = await deps.fetch('/cart.js', { headers: { Accept: 'application/json' } });
      var cart = await cartRes.json();
      if (!cart || !cart.item_count) return { ok: false, reason: 'empty-cart' };
      if (deps.beforeEvent) await deps.beforeEvent(email);
      var res = await post(deps.fetch, 'events', buildCartStartedEvent(email, cart, input.origin, input.source));
      if (!res.ok) return { ok: false, reason: 'request-failed' };
      return { ok: true };
    } catch (e) {
      return { ok: false, reason: 'request-failed' };
    } finally {
      inFlight = false;
    }
  }

  function submitCartSave(input, deps) {
    return sendCartStarted({ email: input.email, source: SOURCE, origin: input.origin }, {
      fetch: deps.fetch,
      beforeEvent: async function (email) {
        if (!input.newsletter) return;
        var res = await post(deps.fetch, 'subscriptions', buildSubscription(email, LIST_NEWSLETTER));
        if (!res.ok) throw new Error('subscription failed');
      }
    });
  }

  var api = { COMPANY_ID: COMPANY_ID, REVISION: REVISION, LIST_NEWSLETTER: LIST_NEWSLETTER, SOURCE: SOURCE, POPUP_SOURCE: POPUP_SOURCE,
    buildReclaimUrl: buildReclaimUrl, buildSubscription: buildSubscription, buildCartStartedEvent: buildCartStartedEvent,
    isValidEmail: isValidEmail, sendCartStarted: sendCartStarted, submitCartSave: submitCartSave };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') window.HarneyCartSaver = api;
  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('klaviyoForms', function (e) {
      var detail = e && e.detail;
      if (!detail || detail.type !== 'submit' || detail.formId !== 'Wbs9eC') return;
      var fields = detail.metaData || {};
      var email = fields['$email'] || fields.email;
      return sendCartStarted({ email: email, source: POPUP_SOURCE, origin: window.location.origin }, { fetch: window.fetch.bind(window) });
    });
  }
  if (typeof window !== 'undefined' && window.customElements && !window.customElements.get('cart-saver')) {
    var KEY = 'harney-cart-saved';
    function savedEmail() { try { return window.sessionStorage.getItem(KEY); } catch (e) { return null; } }
    window.customElements.define('cart-saver', class extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-cart-saver-toggle]');
        this.form = this.querySelector('[data-cart-saver-form]');
        this.status = this.querySelector('[data-cart-saver-status]');
        var saved = savedEmail();
        if (saved) return this.showSaved(saved);
        this.toggle.addEventListener('click', () => {
          var open = this.toggle.getAttribute('aria-expanded') === 'true';
          this.toggle.setAttribute('aria-expanded', String(!open));
          this.form.hidden = open;
          if (!open) this.form.querySelector('input[type="email"]').focus();
        });
        this.form.addEventListener('submit', (e) => { e.preventDefault(); this.submit(); });
      }
      async submit() {
        var button = this.form.querySelector('button[type="submit"]');
        var email = this.form.querySelector('input[type="email"]').value;
        var newsletter = this.form.querySelector('input[type="checkbox"]').checked;
        button.disabled = true;
        this.status.textContent = 'Saving your cart…';
        var r = await submitCartSave({ email: email, newsletter: newsletter, origin: window.location.origin }, { fetch: window.fetch.bind(window) });
        button.disabled = false;
        if (r.ok) { try { window.sessionStorage.setItem(KEY, email.trim()); } catch (e) {} return this.showSaved(email.trim()); }
        if (r.reason === 'in-flight') return;
        this.status.textContent = r.reason === 'invalid-email' ? 'Please enter a valid email address.'
          : r.reason === 'empty-cart' ? 'Your cart is empty.'
          : 'Something went wrong. Please try again.';
      }
      showSaved(email) {
        this.form.hidden = true;
        this.toggle.hidden = true;
        this.status.textContent = 'Saved. We sent your cart to ' + email + '.';
      }
    });
  }
})();
